import * as React from "react";
import { Navigate } from "react-router-dom";
import { UnorderedListOutlined, BarChartOutlined } from "@ant-design/icons";
const Suspense = React.Suspense;
  
const Home = React.lazy(() => import("@/pages/Home")); // 管理中心  
const ImgView = React.lazy(() => import("@/pages/ImgView")); 
const List = React.lazy(() => import("@/pages/List")); 
const Detail = React.lazy(() => import("@/pages/Detail")); 
const ByStages = React.lazy(() => import("@/pages/ByStages")); 
const Error = React.lazy(() => import("@/pages/Error")); 
let routes = [
  {
    path: "/home",
    element: (
      <Suspense>
        <Home />
      </Suspense>
    ), 
  },
  {
    path: "/imgView",
    name: "模块详情",
    element: (
      <Suspense>
        <ImgView />
      </Suspense>
    ),
  }, 
  {
    path: "/userNames",
    name: "账号列表",
    element: (
      <Suspense>
        <List />
      </Suspense>
    ),
  }, 
  {
    path: "/detail",
    name: "账号详情",
    element: (
      <Suspense>
        <Detail />
      </Suspense>
    ),
  }, 
  {
    path: "/bystages",
    name: "分期计算器",
    element: (
      <Suspense>
        <ByStages />
      </Suspense>
    ),
  }, 
  { path: "/", 
    element: (
      <Suspense>        
        <Navigate to="home" />
      </Suspense>
    )
  },
  { path: "*", 
    element: (
      <Suspense>
        <Error />
      </Suspense>
    )
  },
];

export default routes;
